import { z } from 'zod'

export const FormattedAddressData = z.object({
    type: z.literal('FORMATTED'),
    addressLine1: z.string().max(150),
    number: z.string().max(150).optional(),
    street: z.string().max(150).optional(),
    subBuilding: z.string().max(150).optional(),
    city: z.string().max(150),
    regionOrStateCode: z.string().max(100),
    postalCode: z.string().max(20).describe('Postal code, or zip code'),
    poBox: z.string().max(150).optional(),
    countryCode: z
        .string()
        .regex(
            /^[A-Za-z]{3}$/i,
            'countryCode must be an ISO 3166-1 alpha-3 code',
        )
        .optional(),
    isFormatted: z.boolean().default(true),
})

export const UnformattedAddressData = FormattedAddressData.pick({
    addressLine1: true,
    city: true,
    postalCode: true,
    countryCode: true,
    regionOrStateCode: true,
})
    .extend({
        type: z.literal('UNFORMATTED'),
        addressLine2: z.string().max(150).optional(),
        addressLine3: z.string().max(150).optional(),
        addressLine4: z.string().max(150).optional(),
        addressLine5: z.string().max(150).optional(),
        isFormatted: z.boolean().default(false),
    })
    .required({
        postalCode: true,
        countryCode: true,
        regionOrStateCode: true,
        addressLine1: true,
        city: true,
    })
